import { Injectable } from "@angular/core";
import { MediaUpload } from "@shared/db/db-domain.model";
import { db } from "@shared/db/db.repository";
import { DbService } from "@shared/db/db.service";

@Injectable({
    providedIn: 'root',
})

export class MediaUploadStorageService extends DbService<MediaUpload> {
    constructor() {
        super(db.mediaUploads);
    }

    async getFormDataById(id: string): Promise<FormData> {
        const mediaUpload = await this.get(id);
        if (!mediaUpload) return null;

        if (!mediaUpload.fileData) {
            // Stale record from before background uploads stored raw bytes; nothing to recover.
            await this.delete(id);
            return null;
        }

        const formData = new FormData();
        const file = new File([mediaUpload.fileData], mediaUpload.fileName, { type: mediaUpload.fileType });
        formData.append('file', file);
        formData.append('mediaType', mediaUpload.mediaTypeId.toString());
        return formData;
    }
}

